import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import Button from '@dojo/widgets/button';
import { CountdownTimer } from '../widgets/countdown-timer';
import { setQuestion } from '../support/state';
import MCQuestionBase from './mc-base';
import css from '../css/mcquestion.m.css';
let MCQuestionPearsonVue = class MCQuestionPearsonVue extends MCQuestionBase {
    submitted() {
        this.update_result();
        const { question, quizstore } = this.properties;
        question.status = 'question';
        setQuestion(quizstore)({ question });
        this.invalidate();
    }
    render_buttons(which) {
        const { messages } = this.properties.localizedBundle;
        const previousText = messages['previous_question'] || '';
        const nextText = messages['next_question'] || '';
        const reviewText = messages['review'] || '';
        const loadingText = messages['loading'] || '';
        const markText = messages['mark_review'] || '';
        const unmarkText = messages['unmark_review'] || '';
        const { quizstore, onNextQuestion, onPreviousQuestion = () => undefined, hasNextQuestion = () => false, hasPreviousQuestion = () => false, onReview, question, loaded, hasReviewed } = this.properties;
        const { islast = false } = which;
        const { marked = false } = question;
        const buttons = [
            v('div', { classes: [this.theme(css.oneaction), this.theme(css.secondaryButton)] }, [
                w(Button, {
                    key: 'previous',
                    disabled: !hasPreviousQuestion(),
                    onClick: () => {
                        this.update_result();
                        onPreviousQuestion();
                    }
                }, [
                    v('span', {}, [
                        v('i', { classes: ['fas', 'fa-arrow-left', this.theme(css.actionIcon)] }),
                        previousText
                    ])
                ])
            ]),
            v('div', { classes: [this.theme(css.oneaction), hasNextQuestion() ? this.theme(css.primaryButton) : null] }, [
                w(Button, {
                    key: 'next',
                    disabled: !hasNextQuestion(),
                    onClick: () => {
                        this.update_result();
                        onNextQuestion();
                    }
                }, [
                    v('span', {}, [
                        nextText,
                        v('i', { classes: ['fas', 'fa-arrow-right', this.theme(css.actionIcon)] })
                    ])
                ])
            ]),
            v('div', { key: 'mark-div', classes: [this.theme(css.oneaction), this.theme(css.secondaryButton)] }, [
                w(Button, {
                    key: 'mark',
                    aria: { pressed: marked ? 'true' : 'false' },
                    classes: {
                        '@dojo/widgets/button': {
                            root: [marked ? this.theme(css.pressed) : null]
                        }
                    },
                    onClick: () => {
                        question.marked = !question.marked;
                        this.invalidate();
                    }
                }, [
                    marked
                        ? v('span', {}, [
                            v('i', {
                                title: unmarkText,
                                classes: ['fas', 'fa-flag', this.theme(css.actionIcon)]
                            }),
                            unmarkText
                        ])
                        : v('span', {}, [
                            v('i', {
                                title: markText,
                                classes: ['far', 'fa-flag', this.theme(css.actionIcon)]
                            }),
                            markText
                        ])
                ])
            ]),
            v('div', { classes: [this.theme(css.oneaction), this.theme(css.secondaryButton)] }, islast || !hasNextQuestion() || hasReviewed
                ? [
                    w(Button, {
                        key: 'review',
                        disabled: !loaded,
                        onClick: () => {
                            this.update_result();
                            onReview(true);
                        }
                    }, [loaded ? reviewText : loadingText])
                ]
                : []),
            v('div', { key: 'timer', classes: [this.theme(css.timerblock)] }, [
                v('div', { classes: [this.theme(css.timer)] }, [w(CountdownTimer, { quizstore, countdown: '' })])
            ])
        ];
        return buttons;
    }
    render() {
        return this.render_question();
    }
};
MCQuestionPearsonVue = __decorate([
    theme(css)
], MCQuestionPearsonVue);
export { MCQuestionPearsonVue };
export default MCQuestionPearsonVue;
